import { Grid, Hidden, useMediaQuery } from '@mui/material';
import { Container } from '@mui/system';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Menu } from './Menu';
// import { Menu } from './Menu';

const HeaderContainer = styled.header`
  padding: 1rem 0;
  img {
    max-height: 48px;
  }
`;

export const Header = () => {
  const matches = useMediaQuery('(max-width: 768px)');
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <Container>
        <Grid container spacing={2} alignItems='center'>
          <Grid item sm={6} xs={12} align={matches ? 'center' : 'left'}>
            <img src={ process.env.REACT_APP_APP_URL + "images/eskala.svg"} alt="Eskala" className='button-text' onClick={ () => navigate('/cupom')} />
          </Grid>
          <Hidden smDown>
            <Grid item sm={6} xs={12} align='right'>
              <Menu />
            </Grid>
          </Hidden>
        </Grid>
      </Container>
    </HeaderContainer>
  )
}
